import { MentionData } from '@draft-js-plugins/mention'
import styled from 'styled-components'

import { Row } from '@/components/StyledComponents'

interface MentionSuggestionComponentProps {
  id: string
  mention: MentionData
  searchValue?: string
}

const StyledRow = styled(Row)`
  justify-content: flex-start;
  margin-bottom: 5px;
  font-size: 12px;
`
const Description = styled.p`
  font-size: 9px;
  color: grey;
`
const StyledImg = styled.img`
  height: 24px;
  width: 24px;
  margin-right: 15px;
`

const StyledIcon = styled.div`
  svg {
    height: 20px;
    width: 20px;
    margin-right: 5px;
  }
`

const MentionSuggestionComponent = (props: MentionSuggestionComponentProps) => {
  const { mention, searchValue, ...parentProps } = props

  return (
    <div {...parentProps}>
      <StyledRow>
        {typeof mention.icon === 'string' ? (
          <StyledImg src={mention.icon} />
        ) : (
          <StyledIcon> {mention.icon} </StyledIcon>
        )}
        <div>
          <span>{mention.displayName}</span>
          <Description>{mention.name}</Description>
        </div>
      </StyledRow>
    </div>
  )
}

export default MentionSuggestionComponent
